import React, { useMemo } from 'react'
import { StyledSelect } from './styles'

const SelectDefault = ({
  width,
  options = [],
  value: _value,
  onChange,
  optionsValue,
  optionsLabel,
  ...rest
}) => {
  const value = useMemo(
    () => (optionsValue ? _value?.[optionsValue] || _value : _value),
    [_value, optionsValue]
  )

  const optionsWithFirstItemEmpty = useMemo(
    () => [
      {
        [optionsLabel ? optionsLabel : 'label']: '',
        [optionsValue ? optionsValue : 'value']: ''
      },
      ...options
    ],
    [options, optionsLabel, optionsValue]
  )

  return (
    <StyledSelect
      width={width}
      value={value || undefined}
      onChange={onChange}
      {...rest}
    >
      {optionsWithFirstItemEmpty?.map?.((option, index) => (
        <option
          key={index}
          value={optionsValue ? option[optionsValue] : option.value}
        >
          {optionsLabel ? option[optionsLabel] : option.label}
        </option>
      ))}
    </StyledSelect>
  )
}

export default SelectDefault
